import Profile from "src/components/Profile/Profile";
import { LayoutWithSearch } from "src/containers/Layouts/LayoutWithSearch";

export function UserProfile() {
	return (
		<LayoutWithSearch>
			<Profile />
		</LayoutWithSearch>
	);
}
